"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const js_cookie_1 = __importDefault(require("js-cookie"));
const getUserVuid = (user) => {
    let v_uid = "";
    const userV_uid = js_cookie_1.default.get("v_uid");
    if (user && user.loggedUser && user.loggedUser.v_uid) {
        v_uid = user.loggedUser.v_uid;
    }
    else if (userV_uid) {
        v_uid = userV_uid;
    }
    return v_uid;
};
exports.default = getUserVuid;
